import React from 'react';
import { UserProfileResponse } from 'api/minside';

type IProps = {
  user: UserProfileResponse;
};

// Komponenten er en plassholder til innholdet fra AA-registeret er på plass, derfor brukes ikke user ennå
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function AAData({ user }: IProps) {
  return (
    <></>
    // <Row>
    //   <Col lg='8'>
    //     <UserPropertyGroup label='Arbeidsgiver (AA-registeret)' />

    //     <Row>
    //       <Col lg='3'>TBD</Col>
    //     </Row>
    //   </Col>
    // </Row>
  );
}

export default AAData;
